import { CUSTOM_ELEMENTS_SCHEMA, Injectable, NgModule, NO_ERRORS_SCHEMA } from '@angular/core';
import { UserComponent } from './user.component';
import { ProjectListComponent } from './project-list/project-list.component';
import { ProjectDetailsComponent } from './project-details/project-details.component';
import { DocumentStereoTypeComponent } from './manage-documents/document-stereo-type/document-stereo-type.component';
import { StereoTypesSideNavComponent } from './manage-documents/stereo-types-side-nav/stereo-types-side-nav.component';
import { DocumentComponent } from './manage-documents/document/document.component';
import { AddDocumentDialogComponent } from './manage-documents/document/add-document-dialog/add-document-dialog.component';
import { UpdateDocumentDialogComponent } from './manage-documents/document/update-document-dialog/update-document-dialog.component';
import { DocumentUploadComponent } from './manage-documents/document/document-upload/document-upload.component';
import { EditDocumentComponent } from './manage-documents/document/edit-document/edit-document.component';
import { GenericFormComponent } from './manage-documents/document/edit-document/generic-form/generic-form.component';
import { ActivatedRouteSnapshot, DetachedRouteHandle, RouteReuseStrategy, RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { FormlyMaterialModule } from '@ngx-formly/material';
import { SharedModule } from 'projects/shared/src/public-api';
import { UserRoutes } from './user.routing';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FormlyModule } from '@ngx-formly/core';

import { AlSelectTypeComponent } from './manage-documents/document/edit-document/generic-form/custom-types/al-select-type/al-select-type.component';
import { AlTextareaTypeComponent } from './manage-documents/document/edit-document/generic-form/custom-types/al-textarea-type/al-textarea-type.component';
import { AlRadioTypeComponent } from './manage-documents/document/edit-document/generic-form/custom-types/al-radio-type/al-radio-type.component';
import { AlTextInputTypeComponent } from './manage-documents/document/edit-document/generic-form/custom-types/al-text-input-type/al-text-input-type.component';
import { AlCheckboxTypeComponent } from './manage-documents/document/edit-document/generic-form/custom-types/al-checkbox-type/al-checkbox-type.component';
import { AlToggleTypeComponent } from './manage-documents/document/edit-document/generic-form/custom-types/al-toggle-type/al-toggle-type.component';
import { AlFileUploadTypeComponent } from './manage-documents/document/edit-document/generic-form/custom-types/al-file-upload-type/al-file-upload-type.component';
import { ProgressComponent } from './manage-documents/document/edit-document/generic-form/custom-types/al-file-upload-type/progress/progress.component';
import { AlNumberTypeComponent } from './manage-documents/document/edit-document/generic-form/custom-types/al-number-type/al-number-type.component';
import { AlEmailTypeComponent } from './manage-documents/document/edit-document/generic-form/custom-types/al-email-type/al-email-type.component';
import { AgGridModule } from 'ag-grid-angular';
import { UserProjectsButtonRendererComponent } from './project-list/user-projects-button-renderer/user-projects-button-renderer.component';
import { DocumentButtonRendererComponent } from './manage-documents/document/document-button-renderer/document-button-renderer.component';
import { MapComponent } from './map/map.component';
import { NgMaterialModule } from 'projects/main/src/app/ng-material.module';
import { UserProjectsImageRendererComponent } from './project-list/user-projects-image-renderer/user-projects-image-renderer.component';

/**
 * A route strategy allowing for explicit route reuse.
 * Used as a workaround for https://github.com/angular/angular/issues/18374 and https://stackoverflow.com/questions/67575397/angular-11-2-9-routerlink-doesnt-re-initialise-same-component
 * To reuse a given route, add `data: { reuse: true }` to the route definition.
 */
 @Injectable()
 export class CustomRouteReuseStrategy extends RouteReuseStrategy {
 
   public shouldDetach(route: ActivatedRouteSnapshot): boolean {
     return false;
   }
 
   public store(route: ActivatedRouteSnapshot, detachedTree: DetachedRouteHandle | null): void {}
 
   public shouldAttach(route: ActivatedRouteSnapshot): boolean {
     return false;
   }
 
   public retrieve(route: ActivatedRouteSnapshot): DetachedRouteHandle | null {
     return null;
   }
 
   public shouldReuseRoute(future: ActivatedRouteSnapshot, curr: ActivatedRouteSnapshot): boolean {
     // Reuse the route if the RouteConfig is the same, or if both routes use the
     // same component, because the latter can have different RouteConfigs.
     // return (
     //   future.routeConfig === curr.routeConfig ||
     //   Boolean(future.routeConfig?.component && future.routeConfig?.component === curr.routeConfig?.component)
     // );
     return curr.routeConfig === null && future.routeConfig === null;
   } 
 }
 

@NgModule({
  declarations: [
    UserComponent,
    ProjectListComponent,
    ProjectDetailsComponent,
    DocumentStereoTypeComponent,
    StereoTypesSideNavComponent,
    DocumentComponent,
    AddDocumentDialogComponent,
    UpdateDocumentDialogComponent,
    DocumentUploadComponent,
    EditDocumentComponent,
    GenericFormComponent,
    AlSelectTypeComponent, AlTextareaTypeComponent, AlRadioTypeComponent,
    AlTextInputTypeComponent, AlCheckboxTypeComponent, AlToggleTypeComponent, 
    AlFileUploadTypeComponent, ProgressComponent, AlNumberTypeComponent, AlEmailTypeComponent,
    UserProjectsButtonRendererComponent, UserProjectsImageRendererComponent,
    DocumentButtonRendererComponent,
    MapComponent
  ],
  imports: [
    CommonModule,
    //NgbModule,
    FormsModule,
    ReactiveFormsModule,    
    NgMaterialModule,
    FormlyModule,   
    FormlyMaterialModule,
    SharedModule,
    RouterModule.forChild(UserRoutes),
    AgGridModule.withComponents([])
  ],
  providers:[
    {
      provide: RouteReuseStrategy,
      useClass: CustomRouteReuseStrategy,
    }
  ],
  exports: [
    UserComponent,ProjectListComponent,FormlyMaterialModule
  ],
  schemas:[CUSTOM_ELEMENTS_SCHEMA,NO_ERRORS_SCHEMA]
})
export class UserModule { }
